// src/components/pages/MentorshipThanksWrapperArea.jsx
import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import useSWR from "swr";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { SessionContext } from "../../common/SessionContext";

const scrollTop = () =>
  window.scrollTo({ top: 0, behavior: "smooth" });

export default function MentorshipThanksWrapperArea(props) {
  const { session } = useContext(SessionContext);
  const currentCurrency = session.currency;

  const API_URL = `${process.env.REACT_APP_API_FOLDER}get_mentorship_purchase/${props.hash}`;
  const API_TOKEN = process.env.REACT_APP_API_TOKEN;
  const fetcher = url =>
    fetch(url, { headers: { "X-API-TOKEN": API_TOKEN } })
      .then(res => {
        if (!res.ok) throw new Error(`Network response was not ok: ${res.status}`);
        return res.json();
      });

  const { data: mpackage, error, isLoading } = useSWR(API_URL, fetcher);

  if (isLoading) {
    return (
      <div className="contact-wrapper pt-110">
        <div className="container">
          <div className="row align-items-center justify-content-lg-center gy-5">
            <div className="col-lg-6">
              <Skeleton height={300} />
            </div>
            <div className="col-lg-5">
              <Skeleton height={40} width="60%" style={{ marginBottom: 16 }} />
              <Skeleton count={3} />
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (error) {
    return <p className="text-danger">Error loading mentorship package: {error.message}</p>;
  }

  return (
    <div className="contact-wrapper pt-110">
      <div className="container">
        <div className="row align-items-center justify-content-lg-center gy-5">
          <div className="col-lg-6">
            <div className="contatc-intro-figure">
              <img
                src={`${process.env.PUBLIC_URL}/images/banner/booked-bg.png`}
                alt="ContactBannerIMG"
                className="img-fluid"
              />
            </div>
          </div>
          <div className="col-lg-5">
            <div className="booked-info">
              <h3>Thanks!</h3>
              <p>
                We’ve sent an email to{" "}
                <span className="sent_email">{mpackage.customer_email}</span>{" "}
                with confirmation of your mentorship package purchase. Your credits have been stored, and you can now book mentorship sessions via the <a href="https://hub.campfr.com" target="_blank">CAMP Hub</a>.
              </p>
              <p>
                Any problems or questions using your mentorship package, drop us a line at{" "}
                <a href="mailto:hi@campfr.com">hi@campfr.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
